import axios from "../axios";

const upload = (data) => axios.post(`/template-file/upload`, data);

const convertToPdf = (data) => axios.post(`/template-file/convertToPdf`, data);

const update = (data) => axios.put(`/template-file/upload`, data);

const templateFileDataService = {
  upload,
  update,
  convertToPdf,
};

export default templateFileDataService;
